import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../AxiosInstance';
import { trackSupplierAdded } from '../services/analytics';
import { Toast, Field, PageHeader, BtnPrimary } from './v2-utils';
import '../styles/v2.css';

export default function AddSupplierV2() {
  const navigate = useNavigate();
  const location = useLocation();
  const fromUnit     = location.state?.from === 'add_unit';
  const fromEditUnit = location.state?.from === 'edit_unit';
  const editUnitId   = location.state?.unitId;

  const [supplierType, setSupplierType] = useState('supplier');
  const [name, setName]               = useState('');
  const [phone, setPhone]             = useState('');
  const [loc, setLoc]                 = useState('');
  const [loading, setLoading]         = useState(false);
  const [toast, setToast]             = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        source_type: supplierType,
        supplier_name: supplierType === 'supplier' ? name : null,
        market_name:   supplierType === 'market'   ? name : null,
        contact_info: phone,
        location: loc,
      };
      const res = await axiosInstance.post('/suppliers', payload);
      const supplierId = res.data?.supplierId;
      trackSupplierAdded(supplierId);

      if (fromEditUnit && supplierId && editUnitId) {
        sessionStorage.setItem('edit_unit_last_supplier_id', String(supplierId));
        navigate(`/new/dashboard/units/edit/${editUnitId}`);
      } else if (fromUnit && supplierId) {
        sessionStorage.setItem('last_created_supplier_id_add_unit', String(supplierId));
        navigate('/new/dashboard/units/add');
      } else {
        setToast({ message: 'Supplier added successfully!', severity: 'success' });
        setName(''); setPhone(''); setLoc(''); setSupplierType('supplier');
      }
    } catch (err) {
      setToast({ message: err.response?.data?.error || 'Failed to add supplier.', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 620, margin: '0 auto' }}>
      <PageHeader
        title="Add Supplier"
        subtitle="Add a supplier or market to link to your units"
        onBack={() => navigate(fromUnit ? '/new/dashboard/units/add' : '/new/dashboard/suppliers/view')}
      />

      <form onSubmit={handleSubmit}>
        <div className="v2-card" style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 20 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em', margin: 0 }}>Supplier Details</p>

          {/* Type toggle */}
          <Field label="Type">
            <div style={{ display: 'flex', gap: 10 }}>
              {['supplier', 'market'].map(t => (
                <button key={t} type="button"
                  onClick={() => setSupplierType(t)}
                  style={{ flex: 1, padding: '10px 0', borderRadius: 10, border: `1.5px solid ${supplierType === t ? '#10b981' : '#e2e8f0'}`, background: supplierType === t ? '#f0fdf4' : 'white', color: supplierType === t ? '#065f46' : '#475569', fontSize: 13, fontWeight: 700, cursor: 'pointer', textTransform: 'capitalize', transition: 'all 0.15s' }}>
                  {t === 'supplier' ? 'Supplier' : 'Market'}
                </button>
              ))}
            </div>
          </Field>

          <Field label={supplierType === 'supplier' ? 'Supplier Name' : 'Market Name'}>
            <input className="v2-input" type="text" placeholder={supplierType === 'supplier' ? 'e.g. ABC Wholesalers' : 'e.g. Soweto Market'} value={name} onChange={e => setName(e.target.value)} required />
          </Field>

          <Field label="Phone Number" hint="Used for WhatsApp reorder messages (optional)">
            <input className="v2-input" type="tel" placeholder="+260 97 000 0000" value={phone} onChange={e => setPhone(e.target.value)} />
          </Field>

          <Field label="Location" hint="City, area or market section">
            <input className="v2-input" type="text" placeholder="e.g. Lusaka, Soweto Market" value={loc} onChange={e => setLoc(e.target.value)} required />
          </Field>

          <BtnPrimary type="submit" disabled={loading} style={{ marginTop: 4 }}>
            {loading ? 'Saving…' : 'Add Supplier'}
          </BtnPrimary>
        </div>
      </form>

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
